import { type DeviceParameterConfig, Tags } from '@eppendorf/app-configs';
import {
  type HasClassName,
  Icon,
  IconSizeClasses,
} from '@eppendorf/vnls-react-components';
import cn from 'classnames';

import { getIconNameForParameterName } from '$features/monitoring/monitoring.utils';

import styles from './parameter-headline.module.scss';

interface ParameterHeadlineProps extends HasClassName {
  parameterName?: string;
  parameterConfig?: DeviceParameterConfig;
  unit?: string | null;
}

export function ParameterHeadline({
  className,
  parameterName,
  parameterConfig,
  unit,
}: ParameterHeadlineProps) {
  return (
    <div className={cn(styles.parameterHeadline, className)}>
      <Icon
        name={getIconNameForParameterName(parameterName)}
        size={IconSizeClasses.Responsive}
        className={cn(styles.parameterHeadlineIcon, 'ic_parameters')} // fallback if parameter doesn't have an icon yet
      />
      <span className={styles.parameterValue}>
        {parameterName} {unit && `(${unit})`}
      </span>
      {parameterConfig?.tags?.includes(Tags.Extension) && (
        <Icon name="sense-sensor" size={IconSizeClasses.XSmall} />
      )}
    </div>
  );
}
